import { useId } from 'react';
import { useI18n } from '../i18n/i18n-provider';
import type { LocaleCode } from '@event/i18n';

export function LocaleSwitch() {
  const { locale, supportedLocales, setLocale, t } = useI18n();
  const id = useId();

  return (
    <div className="locale-switch">
      <label htmlFor={id} className="locale-switch__label">
        {t('nav.localeSwitch')}
      </label>
      <select
        id={id}
        className="locale-switch__select"
        value={locale}
        onChange={(event) => setLocale(event.target.value as LocaleCode)}
      >
        {supportedLocales.map((code) => (
          <option key={code} value={code}>
            {t(`locale.${code}`)}
          </option>
        ))}
      </select>
    </div>
  );
}
